import isNumber from "../isNumber";

const round = (value, precision) => {
    var multiplier = Math.pow(10, precision || 0);
    return isNumber(value) ? Math.round(value * multiplier)/multiplier : value;  
}

export default round
